"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blank = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var BlankSteps_1 = require("./BlankSteps");
var mediaobject_1 = require("../mediaobject");
var config_context_1 = require("../_util/config-context");
var heading_1 = require("../heading");
var warn_1 = require("../_util/warn");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.Blank = forward_ref_with_statics_1.forwardRefWithStatics(function Blank(_a, ref) {
    var theme = _a.theme, image = _a.image, title = _a.title, description = _a.description, operation = _a.operation, extra = _a.extra, children = _a.children, bottom = _a.bottom, className = _a.className, props = tslib_1.__rest(_a, ["theme", "image", "title", "description", "operation", "extra", "children", "bottom", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (!theme || image) {
        if (bottom && !Array.isArray(bottom)) {
            // eslint-disable-next-line no-param-reassign
            bottom = [bottom];
        }
        return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-card", classPrefix + "-blank-page-v2", className) }, props),
            react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__main" },
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__content" },
                    image.logo && (react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__logo" },
                        react_1.default.createElement("img", { src: image.logo, alt: "logo" }))),
                    react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__title" },
                        react_1.default.createElement("h2", { className: classPrefix + "-blank-page-v2__title-zh" }, title)),
                    children,
                    react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__opreate" },
                        operation,
                        extra && react_1.default.createElement("div", { className: classPrefix + "-mt-4n" }, extra))),
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__picture", style: { backgroundImage: "url(" + image.background + ")" } })),
            bottom && (react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__relative" },
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__relative-inner" }, bottom.map(function (item, index) { return (react_1.default.createElement("p", { key: index, className: classPrefix + "-blank-page-v2__relative-item" }, item)); }))))));
    }
    warn_1.warn("当前 Blank 组件包含将废弃的属性，请尽快升级至最新用法");
    var themeImage = getCustomTheme(theme).image;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-blank-page", {
            "default-error": theme === "error",
            "default-open": theme === "open",
            "default-arrears": theme === "arrears",
            "default-permission": theme === "permission",
        }, className) }, props),
        react_1.default.createElement(mediaobject_1.MediaObject, { align: "middle", media: react_1.default.createElement("div", { className: classPrefix + "-blank-page__media" },
                react_1.default.createElement("span", { className: classPrefix + "-blank-page__media-bg" }, themeImage.background && (react_1.default.createElement("img", { src: themeImage.background, alt: "" }))),
                react_1.default.createElement("span", { className: classPrefix + "-blank-page__media-gif" }, themeImage.gif && react_1.default.createElement("img", { src: themeImage.gif, alt: "" }))) },
            react_1.default.createElement(heading_1.H4, { className: classPrefix + "-mb-2n" }, description),
            children,
            (operation || extra) && (react_1.default.createElement("div", { className: classPrefix + "-blank-page__op" },
                operation,
                extra && react_1.default.createElement("div", { className: classPrefix + "-mt-4n" }, extra))))));
}, {
    Steps: BlankSteps_1.BlankSteps,
});
exports.Blank.displayName = "Blank";
function getCustomTheme(theme) {
    if (typeof theme === "string") {
        return { image: { background: null, gif: null } };
    }
    return tslib_1.__assign({ image: {} }, theme);
}
//# sourceMappingURL=Blank.js.map